import React from 'react'
import InterfaceWrapper from './components/InterfaceWrapper'
import TransactionsMain from './components/TransactionsMain'

const Transactions = props => {
  return <InterfaceWrapper Main={TransactionsMain} {...props} />
}

export default Transactions
